<template>
  <div class="circul8table">
    <section
      class="section no-padding records-posisiton-adjust"
      @mouseleave="checkMouseleave($event)"
    >
      <b-table
        ref="table"
        :data="records"
        :sticky-header="stickyHeaders"
        :narrowed="true"
        :checkable="isCheckable"
        :sticky-checkbox="true"
        :checked-rows.sync="localCheckedRows"
        :is-row-checkable="isRowCheckable"
        :default-sort-direction="defaultSortDirection"
        :sort-icon="sortIcon"
        :sort-icon-size="sortIconSize"
        :hoverable="isHoverable"
        :backend-sorting="backendSortingEnabled"
        @sort="onSort"
        :row-class="AddClassName"
        @dblclick="onDoubleClicked"
        :loading="isLoading"
        @check-all="checkedAll"
        :key="(fields || []).map(c => c.label).join()"
        :class="className"
        :header-checkable="isCheckAll"
        :height="newTableHeight ? newTableHeight : tableHeight"
      >
        <template v-for="col in fields">
          <b-table-column
            :key="col.field"
            :sortable="col.sortable == 1 ? false : true"
            v-bind="col"
            :width="col.width"
            :class="col.class"
            :header-class="col.class"
          >
            <template #header>
              <span v-html="col.label"></span>
              <span
                v-if="col.sortable !== false && isSorted(col.field)"
                class="sort-icon"
                style="margin-left:4px;cursor:pointer;"
                @click="$emit('sort', col.field, getNextSortOrder(col.field))"
              >
                <b-icon
                  :icon="getSortIcon(col.field)"
                  :size="sortIconSize"
                  :class="{ active: isSorted(col.field) }"
                />
              </span>
            </template>
            <template
              v-if="col.searchable && col.type == 'input'"
              #searchable=""
            >
              <b-input
                v-model="col.filterKey[col.field]"
                @keyup.native.enter="searchData"
                @input="enableSearch"
                :custom-class="col.class"
              ></b-input>
            </template>
            <template
              v-else-if="col.searchable && col.type == 'dateField'"
              #searchable=""
            >
              <date-picker
                ref="datePicker"
                :id="col.field"
                v-model="col.filterKey[col.field]"
                placeholder="Select date range"
                @keyup.native.enter="searchData"
                @input="enableSearch()"
                range
                @open="setHandleScrollNeeded"
              >
              </date-picker>
            </template>

            <template
              v-else-if="col.searchable && col.type == 'numberRange'"
              #searchable=""
            >
              <number-range-picker
                :id="col.field"
                v-model="col.filterKey[col.field]"
                placeholder="Select date range"
                @keyup.native.enter="searchData"
                @open="setHandleScrollNeeded"
                @assignNumberRangeValue="assignNumberRangeValue"
                :clearFilter="hideRemoveFilterIcon"
              >
              </number-range-picker>
            </template>

            <template
              v-else-if="col.searchable && col.type == 'multiSelectFilter'"
              #searchable=""
            >
              <div v-if="col.field == 'customer_name'">
                <multiselect
                  ref="multiselect"
                  v-model="col.filterKey[col.field]"
                  :options="col.allStatusVals ? col.allStatusVals : []"
                  placeholder="Select"
                  label="name"
                  track-by="name"
                  :searchable="true"
                  @input="
                    value => {
                      enableSearch(value, col.field);
                      if (col.field === 'customer_name')
                        onCustomerSelectionChange(value, col.field);
                    }
                  "
                  @add="
                    value =>
                      col.field === 'customer_name' &&
                      onCustomerSelectionChange(
                        col.filterKey[col.field],
                        col.field
                      )
                  "
                  @remove="
                    value =>
                      col.field === 'customer_name' &&
                      onCustomerSelectionChange(
                        col.filterKey[col.field],
                        col.field
                      )
                  "
                  @keyup.native.enter="searchData"
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="false"
                  @search-change="getFilteredCustomerTags"
                  :preserve-search="true"
                  :hide-selected="true"
                  :show-labels="false"
                  :limit-text="limitText"
                  :limit="5"
                  @open="setHandleScrollNeeded(col.field, col.type)"
                  data-cy="filter-customers"
                  openDirection="below"
                  :id="col.field"
                  @close="dropdownClose(col.field)"
                >
                  <template slot="selection" slot-scope="{ values, isOpen }"
                    ><span
                      class="multiselect__single"
                      v-if="values.length && !isOpen"
                      >Selected({{ col.filterKey[col.field].length }})</span
                    ></template
                  >
                  <span
                    class="checkbox-label"
                    slot="option"
                    slot-scope="scope"
                    :class="{ 'background-inactive': !scope.option.active }"
                    :title="scope.option.name"
                  >
                    {{ scope.option.name }}
                  </span>
                </multiselect>
              </div>
              <div v-else-if="col.field == 'user'">
                <multiselect
                  ref="multiselect"
                  v-model="col.filterKey[col.field]"
                  :options="col.allStatusVals ? col.allStatusVals : []"
                  placeholder="Select"
                  label="name"
                  track-by="name"
                  :searchable="true"
                  @input="enableSearch"
                  @typing="getFilteredUserTags"
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="false"
                  @search-change="getFilteredUserTags"
                  :preserve-search="true"
                  :hide-selected="true"
                  :show-labels="false"
                  :limit-text="limitText"
                  :limit="5"
                  @open="setHandleScrollNeeded(col.field, col.type)"
                  data-cy="filter-user"
                  openDirection="below"
                  :id="col.field"
                  @close="dropdownClose(col.field)"
                >
                  <template slot="selection" slot-scope="{ values, isOpen }"
                    ><span
                      class="multiselect__single"
                      v-if="values.length && !isOpen"
                      >Selected({{ col.filterKey[col.field].length }})</span
                    ></template
                  >
                  <span
                    class="checkbox-label"
                    slot="option"
                    slot-scope="scope"
                    :title="scope.option.name"
                  >
                    {{ scope.option.name }}
                  </span>
                </multiselect>
              </div>
              <div v-else-if="col.field == 'customer_account_manager'">
                <multiselect
                  ref="multiselect"
                  v-model="col.filterKey[col.field]"
                  :options="col.allStatusVals ? col.allStatusVals : []"
                  placeholder="Select"
                  label="name"
                  track-by="name"
                  :searchable="true"
                  @input="enableSearch"
                  @keyup.native.enter="searchData"
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="false"
                  @search-change="getFilteredCAMTags"
                  :preserve-search="true"
                  :hide-selected="true"
                  :show-labels="false"
                  :limit-text="limitText"
                  :limit="5"
                  @open="setHandleScrollNeeded(col.field, col.type)"
                  data-cy="filter-customer-account-manager"
                  openDirection="below"
                  :id="col.field"
                  @close="dropdownClose(col.field)"
                >
                  <template slot="selection" slot-scope="{ values, isOpen }"
                    ><span
                      class="multiselect__single"
                      v-if="values.length && !isOpen"
                      >Selected({{ col.filterKey[col.field].length }})</span
                    ></template
                  >
                  <template slot="option" slot-scope="scope">
                    <span class="checkbox-label" :title="scope.option.name">
                      {{ scope.option.name }}
                    </span></template
                  >
                </multiselect>
              </div>
              <div
                v-else-if="col.field == 'status' || col.field == 'tags'"
                class="reporting-tracker-status-column"
              >
                <b-dropdown
                  v-model="col.filterKey[col.field]"
                  :data="col.allStatusVals"
                  multiple
                  ref="dropdown"
                  aria-role="list"
                  :scrollable="true"
                  :append-to-body="true"
                  :close-on-click="false"
                  :trap-focus="true"
                  @input="enableSearch"
                  @active-change="
                    setHandleScrollNeeded(col.field, 'dropdown', $event)
                  "
                  data-cy="filter-status"
                  :id="col.field"
                >
                  <template slot="trigger">
                    <button class="button dropdown-button" type="button">
                      <span v-if="col.filterKey[col.field].length > 0"
                        >Selected ({{ col.filterKey[col.field].length }})</span
                      ><span v-else>Select</span>
                      <b-icon icon="menu-down"></b-icon>
                    </button>
                  </template>
                  <b-dropdown-item custom aria-role="listitem">
                    <label class="b-checkbox checkbox">
                      <input
                        type="checkbox"
                        v-model="allSelected"
                        @input="
                          col.filterKey[col.field] = selectAll(
                            col.allStatusVals
                          )
                        "
                      />
                      <span class="check select-checkbox"></span>
                      <span class="control-label">
                        <span class="select-all-label">Select all</span>
                      </span>
                    </label>
                  </b-dropdown-item>
                  <b-dropdown-item
                    custom
                    aria-role="listitem"
                    v-for="(option, index) in col.allStatusVals"
                    :key="index"
                  >
                    <label class="b-checkbox checkbox">
                      <input
                        type="checkbox"
                        v-model="col.filterKey[col.field]"
                        :value="option.name"
                        @input="
                          customItem(
                            col.filterKey[col.field],
                            col.allStatusVals,
                            option.name
                          )
                        "
                      />
                      <span class="check"></span>
                      <span class="control-label">
                        <span>{{ option.name }}</span>
                      </span>
                    </label>
                  </b-dropdown-item>
                </b-dropdown>
              </div>

              <div v-else-if="col.field == 'reporting_responsible'">
                <multiselect
                  ref="multiselect"
                  v-model="col.filterKey[col.field]"
                  :options="col.allStatusVals ? col.allStatusVals : []"
                  placeholder="Select"
                  label="name"
                  track-by="name"
                  :searchable="true"
                  @input="enableSearch"
                  @keyup.native.enter="searchData"
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="false"
                  @search-change="getFilteredRRTags"
                  :preserve-search="true"
                  :hide-selected="true"
                  :show-labels="false"
                  :limit-text="limitText"
                  :limit="5"
                  @open="setHandleScrollNeeded(col.field, col.type)"
                  openDirection="below"
                  data-cy="filter-reporting-responsible"
                  :id="col.field"
                  @close="dropdownClose(col.field)"
                >
                  <template slot="selection" slot-scope="{ values, isOpen }"
                    ><span
                      class="multiselect__single"
                      v-if="values.length && !isOpen"
                      >Selected({{ col.filterKey[col.field].length }})</span
                    ></template
                  >
                  <template slot="option" slot-scope="scope">
                    <span class="checkbox-label" :title="scope.option.name">
                      {{ scope.option.name }}
                    </span></template
                  >
                </multiselect>
              </div>
              <div v-else-if="col.field == 'country'">
                <multiselect
                  ref="multiselect"
                  v-model="col.filterKey[col.field]"
                  :options="col.allStatusVals ? col.allStatusVals : []"
                  placeholder="Select"
                  label="name"
                  track-by="name"
                  :searchable="true"
                  @input="enableSearch"
                  @keyup.native.enter="searchData"
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="false"
                  @search-change="getFilteredCountryTags"
                  :preserve-search="true"
                  :hide-selected="true"
                  :show-labels="false"
                  :limit-text="limitText"
                  :limit="5"
                  @open="setHandleScrollNeeded(col.field, col.type)"
                  data-cy="filter-country"
                  openDirection="below"
                  :id="col.field"
                  @close="dropdownClose(col.field)"
                >
                  <template slot="selection" slot-scope="{ values, isOpen }"
                    ><span
                      class="multiselect__single"
                      v-if="values.length && !isOpen"
                      >Selected({{ col.filterKey[col.field].length }})</span
                    ></template
                  >
                  <template slot="option" slot-scope="scope">
                    <span class="checkbox-label" :title="scope.option.name">
                      {{ scope.option.name }}
                    </span></template
                  >
                </multiselect>
              </div>
              <div v-else>
                <multiselect
                  ref="multiselect"
                  v-model="col.filterKey[col.field]"
                  :options="col.allStatusVals ? col.allStatusVals : []"
                  placeholder="Select"
                  label="name"
                  track-by="name"
                  :searchable="true"
                  @input="enableSearch($event, col.field)"
                  @keyup.native.enter="searchData"
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :preserve-search="true"
                  :hide-selected="true"
                  :show-labels="false"
                  :limit-text="limitText"
                  :limit="5"
                  @open="setHandleScrollNeeded(col.field, col.type)"
                  openDirection="below"
                  :id="col.field"
                  @close="dropdownClose(col.field)"
                >
                  <template slot="selection" slot-scope="{ values, isOpen }"
                    ><span
                      class="multiselect__single"
                      v-if="values.length && !isOpen"
                      >Selected({{ col.filterKey[col.field].length }})</span
                    ></template
                  >
                  <span
                    class="checkbox-label"
                    slot="option"
                    slot-scope="scope"
                    :title="scope.option.name"
                    :class="{
                      'background-inactive': scope.option.active == false
                    }"
                  >
                    {{ scope.option.name }}
                  </span>
                </multiselect>
              </div>
            </template>

            <template
              v-else-if="col.searchable && col.type == 'actionSearch'"
              #searchable="props"
            >
              <div class="filter-action">
                <a href="#">
                  <i
                    :class="{ hidden: hideRemoveFilterIcon }"
                    id="mdi-primary-clear-color"
                    @click.prevent="clearData()"
                    class="mdi mdi-filter-remove-outline mdi-24px"
                    data-cy="clear-filters"
                  >
                  </i>
                </a>
                <a href="#">
                  <i
                    :class="{ greyed: greyedFilterIcon }"
                    id="mdi-primary-color"
                    @click.prevent="searchData()"
                    class="mdi mdi-filter-outline mdi-24px"
                    data-cy="apply-filters"
                  >
                  </i>
                </a>
                {{ props.filters[props.col] }}
              </div>
            </template>

            <template v-else-if="col.type == 'input'" #searchable="">
              <input
                :name="col.field"
                type="text"
                @keyup="enableSearch"
                class="textField"
                @keyup.enter="searchData"
              />
            </template>

            <template v-slot="props">
              <div
                v-if="col.field !== 'actions'"
                :class="classObject(props.row, col.class)"
                @mouseover="checkMouseleave($event)"
              >
                <span v-if="col.countryFlag">
                  <country-flag :country="props.row.code" size="normal" />
                </span>
                <span v-else-if="col.customSwitchComponent">
                  <b-field>
                    <b-switch
                      v-model="props.row[col.field]"
                      passive-type="is-danger"
                      type="is-success"
                      :disabled="col.disableSwitch"
                      @input="requiredRow($event, props.row.id)"
                    >
                    </b-switch>
                  </b-field>
                </span>
                <span v-else-if="col.routerFlag && col.isRouteAllowed">
                  <router-link
                    :to="{
                      name: col.routerLink,
                      params: { id: props.row.id, row: props.row }
                    }"
                  >
                    {{ props.row[col.field] }}
                  </router-link>
                </span>
                <span v-else-if="col.isLink">
                  <a href="#" @click="linkableColumn(props.row)">
                    {{ props.row[col.field] }}
                  </a>
                </span>
                <span v-else class="show-inline">
                  <span
                    v-if="
                      (Array.isArray(props.row[col.field]) &&
                        props.row[col.field].length > 0) ||
                        (!Array.isArray(props.row[col.field]) &&
                          props.row[col.field] !== undefined &&
                          props.row[col.field] !== null &&
                          props.row[col.field] !== '' &&
                          !(
                            typeof props.row[col.field] === 'string' &&
                            props.row[col.field].trim() === ''
                          ))
                    "
                  >
                    <span
                      class="b-tooltips"
                      v-if="props.row[col.field].length > maxTextLength"
                    >
                      <span v-if="props.row[col.label] == 'Comments'"
                        >{{
                          props.row[col.field].substring(0, maxTextLength)
                        }}...
                        <span
                          v-if="col.additionalInfo && props.row[col.field]"
                          class="additional-info"
                          v-on:click="showComment(props.row[col.field])"
                          ><a href="#"
                            ><i :class="col.additionalInfoIcon"></i></a></span
                      ></span>
                      <span v-else>
                        <b-tooltip
                          :label="props.row[col.field].split(',').join(', ')"
                          multilined
                          position="is-top"
                          size="is-large"
                        >
                          {{
                            props.row[col.field].substring(0, maxTextLength)
                          }}...
                        </b-tooltip>
                        <span
                          v-if="col.uriLink"
                          @click.prevent="redirectToKDB(props.row.url)"
                        >
                          <b-icon size="is-small" icon="open-in-new"></b-icon>
                        </span>
                      </span>
                    </span>
                    <span v-else>
                      <div v-html="props.row[col.field]"></div>
                      <span
                        v-if="col.uriLink"
                        @click.prevent="redirectToKDB(props.row.url)"
                      >
                        <b-icon
                          size="is-small"
                          icon="open-in-new"
                        ></b-icon> </span
                    ></span>
                  </span>
                  <span v-else>NA</span>

                  <span
                    v-if="
                      col.additionalInfo &&
                        props.row[col.additionalInfoFieldName]
                    "
                    class="additional-info"
                    >&nbsp;<i
                      :class="col.additionalInfoIcon"
                      v-on:click="
                        showContent(props.row[col.additionalInfoFieldName])
                      "
                    >
                    </i
                  ></span>
                  <span
                    v-if="
                      col.download &&
                        props.row[col.field] &&
                        props.row[col.field + '_file_count'] < 2
                    "
                    class="additional-download"
                    @click.prevent="downloadContent(props.row, col)"
                    ><a href="#"><i :class="col.downloadIcon"></i></a
                  ></span>
                  <span v-if="col.actionIcon" class="additional-action"
                    >&nbsp;<a href="#"
                      ><i
                        :class="col.actionIcon"
                        @click.prevent="onActionIconClick(props.row, col)"
                      >
                      </i></a
                  ></span>
                </span>
              </div>
              <div
                @mouseover="checkMouseHover($event)"
                @mouseleave="checkMouseleave($event)"
                v-else
              >
                <div class="action-icon" v-if="routeNext">
                  <router-link
                    v-if="props.row.actions && !isViewOnly"
                    :to="{
                      name: linkEdit,
                      params: { id: props.row.id, row: props.row }
                    }"
                    data-cy="c8-table-edit"
                  >
                    <i class="mdi mdi-pencil mdi-24px"> </i>
                  </router-link>
                  <i
                    v-else-if="!isViewOnly"
                    class="mdi mdi-pencil mdi-24px disabled"
                  ></i>
                  <router-link
                    v-if="customLinkView && props.row.disabledView"
                    :to="{
                      name: linkViewforImport(customLinkView, props.row),
                      params: { id: props.row.id, row: props.row }
                    }"
                    data-cy="c8-table-view"
                  >
                    <span><i class="mdi mdi-eye-outline mdi-24px"></i></span>
                  </router-link>
                  <router-link
                    v-else-if="customLinkView && !props.row.disabledView"
                    to="#"
                  >
                    <span
                      ><i class="mdi mdi-eye-outline mdi-24px disabled"></i
                    ></span>
                  </router-link>
                  <router-link
                    v-else
                    :to="{
                      name: linkView,
                      params: { id: props.row.id, row: props.row }
                    }"
                    data-cy="c8-table-view"
                  >
                    <span><i class="mdi mdi-eye-outline mdi-24px"></i></span>
                  </router-link>
                  <a
                    v-if="enableSwitchAction"
                    @click="switchView(props.row)"
                    class="mdi mdi-account-switch-outline mdi-24px"
                    data-cy="c8-table-switch"
                  ></a>
                  <a
                    v-if="showHistoryButton"
                    class="mdi mdi-history mdi-24px"
                    data-cy="c8-table-history"
                    @click="historyAction(props.row)"
                  >
                  </a>
                  <a
                    @click="hideActionIcon($event)"
                    class="mdi mdi-dots-horizontal-circle-outline mdi-24px"
                  ></a>
                </div>
                <div v-else-if="isViewOnly && !routeNext">
                  <a v-if="showViewButton" href="#">
                    <i
                      @click.prevent="viewModal(props.row)"
                      class="mdi mdi-eye-outline mdi-24px"
                    ></i>
                  </a>
                </div>
                <div class="level-left action-icon" v-else>
                  <a v-if="showEditButton" href="#"
                    ><i
                      v-if="props.row.actions"
                      @click.prevent="editModal(props.row)"
                      class="mdi mdi-pencil mdi-24px"
                      data-cy="c8-table-edit"
                    >
                    </i
                    ><i
                      v-else
                      class="mdi mdi-pencil mdi-24px disabled"
                      data-cy="c8-table-edit"
                    >
                    </i
                  ></a>

                  <a
                    v-if="showPlayButton && disablePlayButtonAction(props.row)"
                    class="mdi mdi-play mdi-24px"
                    @click="playAction(props.row)"
                    data-cy="c8-table-play"
                  >
                  </a>

                  <a
                    v-if="showPlayButton && !disablePlayButtonAction(props.row)"
                    class="mdi mdi-play mdi-24px disabled"
                    data-cy="c8-table-play"
                  >
                  </a>
                  <a
                    v-if="showCopyButton"
                    class="mdi mdi-content-copy mdi-24px"
                    data-cy="c8-table-copy"
                    @click="copyAction(props.row)"
                  >
                  </a>
                  <a v-if="showViewButton" href="#">
                    <i
                      v-if="props.row.disabledView"
                      class="mdi mdi-eye-outline mdi-24px disabled"
                    ></i>
                    <i
                      v-else
                      @click.prevent="viewModal(props.row)"
                      class="mdi mdi-eye-outline mdi-24px"
                      data-cy="c8-table-view"
                    ></i>
                  </a>
                  <a href="#" v-if="showRemoveButton">
                    <i
                      v-if="props.row.delete"
                      @click.prevent="deleteModal(props.row)"
                      class="mdi mdi-delete mdi-24px"
                      data-cy="c8-table-delete"
                    >
                    </i>
                    <i
                      v-else
                      class="mdi-disable-delete-btn mdi mdi-delete mdi-24px"
                    >
                    </i>
                  </a>
                  <a
                    @click="hideActionIcon($event)"
                    class="mdi mdi-dots-horizontal-circle-outline mdi-24px"
                  ></a>
                </div>

                <a
                  v-if="!isThreeDot"
                  @click="showActionIcon($event)"
                  class="show-action-icon mdi mdi-dots-horizontal-circle-outline mdi-24px"
                ></a>
              </div>
            </template>
          </b-table-column>
        </template>
        <template slot="empty">
          <div
            class="is-empty-table"
            :style="{
              height: newTableHeight
                ? typeof newTableHeight === 'string'
                  ? newTableHeight
                  : newTableHeight + 'px'
                : tableHeight + 'px',
              maxHeight: newTableHeight
                ? typeof newTableHeight === 'string'
                  ? newTableHeight
                  : newTableHeight + 'px'
                : tableHeight + 'px'
            }"
          >
            <div class="is-empty-content">
              <img :src="emptyTableIcon" class="img-rectangle" />
              <p>{{ noDataMsg }}</p>
            </div>
          </div>
        </template>
        <template #footer> </template>
      </b-table>
      <b-pagination
        v-if="pagination"
        :total="total"
        v-model="current"
        :range-before="rangeBefore"
        :range-after="rangeAfter"
        :order="order"
        :size="size"
        :simple="isSimple"
        :rounded="isRounded"
        :per-page="perPage"
        :icon-prev="prevIcon"
        :icon-next="nextIcon"
        aria-next-label="Next page"
        aria-previous-label="Previous page"
        aria-page-label="Page"
        aria-current-label="Current page"
      >
      </b-pagination>
      <template v-if="enableLoadMore">
        <div class="has-text-centered margin-top-small">
          <b-button
            type="is-primary"
            size="is-small"
            @click="loadMoreData"
            class="button-load-more"
            >Load more</b-button
          >
        </div>
      </template>
    </section>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import Multiselect from "vue-multiselect";
import NumberRangePicker from "./NumberRangePicker.vue";
let screenPixelSize;
let pixelRatio;
// @group Circulate Table
export default {
  name: "circul8-table",
  components: { DatePicker, Multiselect, NumberRangePicker },

  props: {
    className: {
      type: String
    },
    tableName: {
      type: String
    },
    // Data to be displayed in table
    records: {
      type: Array
    },
    // table columns
    fields: {
      type: Array
    },
    // edit url
    linkEdit: {
      type: String
    },
    // maximum text length of cell in table row
    maxTextLength: {
      type: [String, Number]
      // default: 16
    },
    // view url
    linkView: {
      type: String
    },
    // open view in another tab or in modal within the same page
    routeNext: {
      type: Boolean,
      default: true
    },
    // hide three dots
    isThreeDot: {
      type: Boolean,
      default: false
    },
    isViewOnly: {
      type: Boolean,
      default: false
    },
    // show or hide pagination in the table
    pagination: {
      type: Boolean,
      default: false
    },
    // selected rows for bulk operations
    checkedRows: {
      type: Array,
      default: () => []
    },

    isCheckable: {
      type: Boolean,
      default: true
    },
    stickyHeaders: {
      type: Boolean,
      default: true
    },

    // show or hide delete button in table
    showRemoveButton: {
      type: Boolean,
      default: false
    },
    // list of streams to be used in dropdown for search
    allStreams: {
      type: Array,
      default: () => []
    },
    // list of frequencies to be used in dropdown for search
    allFrequencies: {
      type: Array,
      default: () => []
    },
    // show or hide edit button in table
    showEditButton: {
      type: Boolean,
      default: false
    },
    // show or hide edit button in table
    showViewButton: {
      type: Boolean,
      default: true
    },
    // list of the countries to be used in dropdown for search
    allCountries: {
      type: Array,
      default: () => []
    },
    // list of customer account manager to be used in dropdown for search
    allCAMs: {
      type: Array,
      default: () => []
    },
    // list of reporting responsible to be used in dropdown for search
    allRRs: {
      type: Array,
      default: () => []
    },
    // list of customers to be used in dropdown for search
    allCustomers: {
      type: Array,
      default: () => []
    },
    // list of users to be used in dropdown for search
    allUsers: {
      type: Array,
      default: () => []
    },
    // list of reporting tracker status to be used in dropdown for search
    allStatus: {
      type: Array,
      default: () => []
    },
    // list of all product family to be used in dropdown population
    allProductFamily: {
      type: Object
    },
    // list of material details to be used in dropdown population
    allMaterialDetail: {
      type: Object
    },
    // enable or disbale load more in table
    enableLoadMore: {
      type: Boolean,
      default: false
    },
    // enable or disable backend sort
    backendSortingEnabled: {
      type: Boolean,
      default: false
    },
    listingComponent: {
      type: Boolean,
      default: false
    },
    whichComponent: {
      type: String,
      default: ""
    },
    enableSwitchAction: {
      type: Boolean,
      default: false
    },
    whiteSpaceNormal: {
      type: Boolean,
      default: false
    },
    saveDataFields: {
      type: Boolean,
      default: false
    },

    rowClickable: {
      type: Boolean,
      default: false
    },
    // show or hide loading icon
    isLoading: {
      type: Boolean,
      default: false
    },

    enableInfiniteScroll: {
      type: Boolean,
      default: false
    },
    hasNextData: {
      type: Boolean,
      default: true
    },
    hasPreviousData: {
      type: Boolean,
      default: true
    },
    customLinkView: {
      type: String
    },
    showPlayButton: {
      type: Boolean,
      default: false
    },
    showCopyButton: {
      type: Boolean,
      default: false
    },
    showHistoryButton: {
      type: Boolean,
      default: false
    },
    isExtertenal: {
      type: Boolean,
      default: false
    },
    noDataMsg: {
      type: String,
      default: "No results were found"
    },
    productFamilyDropDown: {
      type: Array,
      default: () => []
    },
    materialDetailDropDown: {
      type: Array,
      default: () => []
    },
    isCheckAll: {
      type: Boolean,
      default: true
    },
    allowOnlyOneSelection: {
      type: Boolean,
      default: false
    },
    newTableHeight: {
      type: [String, Number],
      default: null
    }
  },

  watch: {
    fields: {
      handler(newValue) {
        if (Array.isArray(newValue)) {
          newValue.forEach(col => {
            if (col && col.filterKey && typeof col.filterKey === "object") {
              Object.keys(col.filterKey).forEach(key => {
                // You can perform any logic here for each filterKey value
                if (
                  col.filterKey[key] &&
                  col.filterKey[key] != "name" &&
                  col.filterKey[key] != ""
                ) {
                  this.hideRemoveFilterIcon = false;
                }
              });
            }
          });
        }
        this.$nextTick(() => {
          this.attachTableScroll();
        });
      },
      deep: true
    },
    checkedRows(newValue) {
      this.localCheckedRows = newValue;
    },
    localCheckedRows(newValue) {
      this.$emit("clickcheck", newValue);
    },
    records() {
      if (this.allRecords.length == 0 && this.records) {
        this.allRecords = JSON.parse(JSON.stringify(this.records));
      }
    }
  },
  data() {
    return {
      hideRemoveFilterIcon: true,
      greyedFilterIcon: false,
      allSelected: false,
      customers: [],
      streams: [],
      frequencies: [],
      status: [],
      country: [],
      customer_account_manager: [],
      reporting_responsible: [],
      countries: [],
      handleScrollNeeded: false,
      datePicker: "date-picker",
      dateSearchable: false,
      total: 15,
      current: 1,
      perPage: 10,
      rangeBefore: 3,
      rangeAfter: 1,
      size: "is-small",
      defaultSortDirection: "asc",
      sortIcon: "arrow-up",
      sortIconSize: "is-small",
      allRecords: [],
      dateFilterMap: {},
      query: "",
      subHeight: 0,
      isHoverable: true,
      scrollheight: null,
      targetedTable: null,
      emptyTableIcon: require("@/assets/database-search.png"),
      localCheckedRows: this.checkedRows,
      tableHeight: 500
    };
  },
  mounted() {
    this.attachTableScroll();
    window.addEventListener("scroll", this.handleAnyScroll, true);
    window.addEventListener("mousewheel", this.handleDropdownScroll, {
      capture: true,
      passive: false
    });
    if (this.whichComponent == "CP") {
      window.addEventListener("scroll", this.handleAnyScroll, true);
      this.subHeight = 275;
    } else {
      this.subHeight = 310;
    }
    if (this.listingComponent) {
      this.$nextTick(function() {
        window.addEventListener("resize", () => {
          this.checkSize();
          this.adjustHeight();
        });

        this.checkSize();
        this.adjustHeight();
      });
    }
    if (this.saveDataFields && localStorage.getItem(this.tableName + "Query")) {
      this.hideRemoveFilterIcon = false;
    }
    if (
      this.isExtertenal &&
      this.saveDataFields &&
      localStorage.getItem(this.tableName + "QueryExternal")
    ) {
      this.hideRemoveFilterIcon = false;
    }
  },
  updated() {
    this.adjustTableHeight();
  },
  beforeDestroy() {
    this.detachTableScroll();
    window.removeEventListener("scroll", this.handleAnyScroll, true);
    window.removeEventListener("mousewheel", this.handleDropdownScroll, {
      capture: true,
      passive: false
    });
  },
  beforedestroyed() {
    window.addEventListener("resize", () => {
      this.checkSize();
      this.adjustHeight();
    });
    document
      .querySelector(".table-wrapper")
      .removeEventListener("scroll", this.handleScroll);
  },

  methods: {
    getSortIcon(field) {
      if (this.sortField === field) {
        return this.sortOrder === "desc" ? "arrow-down" : "arrow-up";
      }
      return "arrow-up";
    },
    isSorted(field) {
      return this.sortField === field;
    },
    getNextSortOrder(field) {
      if (this.sortField !== field) return "asc";
      return this.sortOrder === "asc" ? "desc" : "asc";
    },
    onSort(field, order) {
      this.sortField = field;
      this.sortOrder = order;
      document.querySelector(".table-wrapper").scrollTop = 1;
      this.$emit("backendSort", field, order, this.query);
    },
    adjustTableHeight() {
      if (this.newTableHeight) {
        const wrapper = this.$el.querySelector(".table-wrapper");
        if (wrapper) {
          const heightValue =
            typeof this.newTableHeight === "string"
              ? this.newTableHeight
              : `${this.newTableHeight}px`;
          wrapper.style.maxHeight = heightValue;
          wrapper.style.height = heightValue;
        }
      }
    },
    handleAnyScroll(e) {
      if (
        e.target.classList &&
        (e.target.classList.contains("multiselect__content-wrapper") ||
          e.target.classList.contains("multiselect__content") ||
          // Add these classes to check for Buefy dropdown content
          e.target.classList.contains("dropdown-content") ||
          e.target.classList.contains("dropdown-item") ||
          e.target.closest(".dropdown-content")) // Check parent elements too
      ) {
        // Don't close dropdowns when scrolling inside them
        return;
      }

      // Otherwise, close all dropdowns
      if (this.$refs.multiselect) {
        const multiselects = Array.isArray(this.$refs.multiselect)
          ? this.$refs.multiselect
          : [this.$refs.multiselect];
        multiselects.forEach(ms => {
          if (ms && typeof ms.deactivate === "function") ms.deactivate();
        });
      }

      if (this.$refs.dropdown) {
        const dropdowns = Array.isArray(this.$refs.dropdown)
          ? this.$refs.dropdown
          : [this.$refs.dropdown];
        dropdowns.forEach(dd => {
          if (dd && typeof dd.close === "function") dd.close();
          if (dd && typeof dd.isActive !== "undefined") dd.isActive = false;
        });
      }

      if (this.$refs.datePicker) {
        const datePickers = Array.isArray(this.$refs.datePicker)
          ? this.$refs.datePicker
          : [this.$refs.datePicker];
        datePickers.forEach(dp => {
          if (dp && typeof dp.closePopup === "function") dp.closePopup();
        });
      }
    },
    attachTableScroll() {
      const tableRef = this.$refs.table;
      if (tableRef && tableRef.$el) {
        const listElm = tableRef.$el.querySelector(".table-wrapper");
        if (listElm) {
          listElm.removeEventListener("scroll", this.handleTableScroll);
          listElm.addEventListener("scroll", this.handleTableScroll);
        }
      }
    },
    detachTableScroll() {
      const tableRef = this.$refs.table;
      if (tableRef && tableRef.$el) {
        const listElm = tableRef.$el.querySelector(".table-wrapper");
        if (listElm) {
          listElm.removeEventListener("scroll", this.handleTableScroll);
        }
      }
    },
    handleTableScroll(e) {
      const listElm = e.target;
      if (
        this.enableInfiniteScroll &&
        Math.round(listElm.scrollTop) +
          Math.round(listElm.clientHeight) -
          Math.round(listElm.scrollHeight) >=
          -5
      ) {
        if (this.hasNextData) {
          this.loadMoreData();
          listElm.scrollTop = 50;
        }
      } else if (
        this.enableInfiniteScroll &&
        Math.round(listElm.scrollTop) == 0 &&
        this.hasPreviousData
      ) {
        this.loadMorePreviousData();
        listElm.scrollTop =
          Math.round(listElm.scrollHeight) -
          Math.round(listElm.clientHeight) -
          50;
      }
      if (this.handleScrollNeeded) {
        this.handleScroll();
      }
    },
    // Only allow checking if no row is checked or this is the checked row
    isRowCheckable(row) {
      if (!this.allowOnlyOneSelection) return true;
      return (
        this.checkedRows.length === 0 ||
        this.checkedRows.some(checked => checked.id === row.id)
      );
    },
    linkableColumn(value) {
      this.$emit("linkableColumn", value);
    },
    redirectToKDB(url) {
      window.open(url, "_blank");
    },
    checkedAll(value) {
      this.$emit("checkedAll", value.length > 0 ? true : false);
    },
    /**
     * @vuese
     * redirect to view or edit page if the row is double clicked
     * redirect to edit page if the user has edit access right otherwise redirect view page
     */

    checkMouseHover(e) {
      if (e)
        this.targetedTable = e.currentTarget.parentNode.parentNode.parentNode;
      const elems =
        this.targetedTable &&
        this.targetedTable.querySelectorAll(".action-icon");
      if (elems) {
        for (let i = 0; i < elems.length; i++) {
          elems.item(i).style.display = "block";
        }
      }
      const showElems =
        this.targetedTable &&
        this.targetedTable.querySelectorAll(".show-action-icon");
      if (showElems) {
        for (let i = 0; i < showElems.length; i++) {
          showElems.item(i).style.display = "none";
        }
      }
    },
    checkMouseleave(e) {
      if (e.toElement && e.toElement.className !== "is-actions") {
        const target = e.currentTarget.parentNode.parentNode.parentNode;
        const elems = target.querySelectorAll(".action-icon");
        for (let i = 0; i < elems.length; i++) {
          elems.item(i).style.display = "none";
        }
        const showElems = target.querySelectorAll(".show-action-icon");
        for (let i = 0; i < showElems.length; i++) {
          showElems.item(i).style.display = "block";
        }
      }
    },
    onDoubleClicked(row) {
      if (this.rowClickable) {
        if (row.actions) {
          this.$router.push(`${this.$route.path.split("/")[1]}/edit/${row.id}`);
        } else {
          this.$router.push(`${this.$route.path.split("/")[1]}/view/${row.id}`);
        }
      }
    },
    /**
     * @vuese
     * emit loadNextPage event
     */
    loadMoreData() {
      // get the records of next page
      this.$emit("loadNextPage");
    },
    loadMorePreviousData() {
      // get the records of next page
      this.$emit("loadPreviousPage");
    },
    switchView(row) {
      this.$emit("switchCustomerView", row);
    },
    disablePlayButtonAction(row) {
      const status = [
        "New",
        "Failed",
        "Calculated",
        "Rejected",
        "Rejected by Customer",
        "Rejected by CAM"
      ];
      try {
        if (this.find_column_index("report_status") > -1) {
          if (status.includes(row.report_status) && row.active) return true;
          else return false;
        }
      } catch (error) {
        // do nothing
      }
    },

    playAction(row) {
      this.$emit("playActionClicked", row);
    },
    copyAction(row) {
      this.$emit("copy", row);
    },
    historyAction(row) {
      this.$emit("history", row);
    },
    requiredRow(newValue, id) {
      this.$emit("switchRequire", [newValue, id]);
    },
    /**
     * @vuese
     * hide search icon
     * @arg The argument click event handler
     */
    hideActionIcon(e) {
      e.currentTarget.parentNode.style.display = "none";
      //document.getElementById("show-action-icon").style.display = "block"

      e.currentTarget.parentNode.nextElementSibling.style.display = "block";
    },
    /**
     * @vuese
     * enable search icon
     * @arg The argument is click event handler
     */
    showActionIcon(e) {
      const elems = document.querySelectorAll(".action-icon");
      for (let i = 0; i < elems.length; i++) {
        elems.item(i).style.display = "none";
      }
      const showElems = document.querySelectorAll(".show-action-icon");
      for (let i = 0; i < showElems.length; i++) {
        showElems.item(i).style.display = "block";
      }

      e.currentTarget.previousElementSibling.style.display = "block";

      e.currentTarget.style.display = "none";
    },
    /**
     * @vuese
     * emit sort event
     * @args The arguments are field and order
     */
    // onSort(field, order) {
    //   document.querySelector(".table-wrapper").scrollTop = 1;
    //   this.$emit("backendSort", field, order, this.query);
    // },

    adjustHeight() {
      const browser_height = window.innerHeight;
      const newTableHeight =
        browser_height - this.subHeight > 1800
          ? 1800
          : browser_height - this.subHeight;
      const query = document.querySelector(".table-wrapper");
      query ? (query.style.maxHeight = newTableHeight + "px") : "";

      this.tableHeight = newTableHeight;
    },
    setHandleScrollNeeded(fieldId, type, event) {
      this.handleScrollNeeded = true;
      if (type == "multiSelectFilter" || (type == "dropdown" && event)) {
        const querySelector = document.getElementById(fieldId);
        const dropdown = querySelector.parentNode.parentNode;
        const rect = querySelector.parentNode.getBoundingClientRect();
        dropdown.style.left = rect.left + 0 + "px";
        dropdown.style.top = rect.top + 0 + "px";
        querySelector.parentNode.parentNode.style.position = "fixed";
        querySelector.parentNode.parentNode.style.width = "max-content";
        querySelector.parentNode.parentNode.style.maxWidth = "350px";

        // Add event listener to prevent dropdown closing on scroll
        if (type == "dropdown" && event) {
          this.$nextTick(() => {
            const dropdownMenu = dropdown.querySelector(".dropdown-menu");
            if (dropdownMenu && !dropdownMenu._hasScrollListener) {
              dropdownMenu._hasScrollListener = true;
              dropdownMenu.addEventListener(
                "wheel",
                e => {
                  e.stopPropagation();
                },
                { passive: true }
              );
            }
          });
        }
      }
      if (type == "dropdown" && !event) {
        const querySelector = document.getElementById(fieldId);
        const dropdown = querySelector.parentNode.parentNode;
        dropdown.style.position = "relative";
        dropdown.style.width = "inherit";
        dropdown.style.left = 0 + "px";
        dropdown.style.top = 0 + "px";
      }
    },

    dropdownClose(fieldId) {
      const querySelector = document.getElementById(fieldId);
      const dropdown = querySelector.parentNode.parentNode;
      dropdown.style.position = "relative";
      dropdown.style.width = "inherit";
      dropdown.style.left = 0 + "px";
      dropdown.style.top = 0 + "px";
    },

    handleScroll() {
      this.handleScrollNeeded = false;
      this.$refs.multiselect &&
        this.$refs.multiselect.forEach(element => {
          element.deactivate();
        });
      this.$refs.dropdown &&
        this.$refs.dropdown.forEach(element => {
          element.isActive = false;
        });
      this.$refs.datePicker &&
        this.$refs.datePicker.forEach(element => {
          element.closePopup();
        });
    },
    checkSize() {
      screenPixelSize = screen.width;
      pixelRatio =
        window.devicePixelRatio ||
        window.screen.availWidth / document.documentElement.clientWidth;
      pixelRatio = pixelRatio.toFixed(1);
      if (
        (screenPixelSize > 1024 &&
          screenPixelSize < 1281 &&
          pixelRatio == 1.5) ||
        (screenPixelSize > 1580 && screenPixelSize < 1921 && pixelRatio == 1.5)
      ) {
        this.subHeight = this.subHeight - 15;
      }
    },
    /**
     *  @vuese
     * return filtered customer list
     * @args The argument is the string entered
     */
    getFilteredCustomerTags(text) {
      const customerIndex = this.find_column_index("customer_name");

      this.fields[customerIndex]["allStatusVals"] = this.allCustomers.filter(
        option => {
          return (
            option.name
              .toString()
              .toLowerCase()
              .indexOf(text.toLowerCase()) >= 0
          );
        }
      );
    },
    /**
     *  @vuese
     * return filtered users list
     * @args The argument is the string entered
     */
    getFilteredUserTags(text) {
      const customerIndex = this.find_column_index("user");

      this.fields[customerIndex]["allStatusVals"] = this.allUsers.filter(
        option => {
          return (
            option.name
              .toString()
              .toLowerCase()
              .indexOf(text.toLowerCase()) >= 0
          );
        }
      );
    },
    /**
     *  @vuese
     * return filtered countries list
     * @args The argument is the string entered
     */
    getFilteredCountryTags(text) {
      const countryIndex = this.find_column_index("country");
      this.fields[countryIndex]["allStatusVals"] = this.allCountries.filter(
        option => {
          return (
            option.name
              .toString()
              .toLowerCase()
              .indexOf(text.toLowerCase()) >= 0
          );
        }
      );
    },
    /**
     * @vuese
     * return filtered customer account manager list
     * @args The argument is the string entered
     */
    getFilteredCAMTags(text) {
      const camIndex = this.find_column_index("customer_account_manager");
      this.fields[camIndex]["allStatusVals"] = this.allCAMs.filter(option => {
        return (
          option.name
            .toString()
            .toLowerCase()
            .indexOf(text.toLowerCase()) >= 0
        );
      });
    },
    /**
     * @vuese
     * return filtered reporting responsible list
     * @args The argument is the string entered
     */
    getFilteredRRTags(text) {
      const rrIndex = this.find_column_index("reporting_responsible");
      if (rrIndex > -1) {
        this.fields[rrIndex]["allStatusVals"] = this.allRRs.filter(option => {
          return (
            option.name
              .toString()
              .toLowerCase()
              .indexOf(text.toLowerCase()) >= 0
          );
        });
      }
    },
    /**
       * @vuese
       * enable dependable dropdown

       */
    checkDependancy(item, field) {
      if (field && item.length > 0) {
        item = item.filter(element => {
          return element.name != "NA";
        });
      }

      if (field == "product_group") {
        const ProductFamilyIndex = this.find_column_index("product_family");
        this.fields[ProductFamilyIndex]["allStatusVals"] = [];
        item.forEach(element => {
          for (item of this.allProductFamily[`${element.name}`].filter(
            u => u != "NA"
          )) {
            this.fields[ProductFamilyIndex]["allStatusVals"].push({
              name: item
            });
          }
        });
        if (item.length == 0) {
          this.fields[ProductFamilyIndex][
            "allStatusVals"
          ] = this.productFamilyDropDown;
        } else {
          this.fields[ProductFamilyIndex]["allStatusVals"].push({
            name: "NA"
          });
        }
      }
      if (field == "material_general") {
        const materialDetailIndex = this.find_column_index("material_detail");
        this.fields[materialDetailIndex]["allStatusVals"] = [];
        item.forEach(element => {
          for (item of this.allMaterialDetail[`${element.name}`].filter(
            u => u != "NA"
          )) {
            this.fields[materialDetailIndex]["allStatusVals"].push({
              name: item
            });
          }
        });
        if (item.length == 0) {
          this.fields[materialDetailIndex][
            "allStatusVals"
          ] = this.materialDetailDropDown;
        } else {
          this.fields[materialDetailIndex]["allStatusVals"].push({
            name: "NA"
          });
        }
      }
    },
    // Add this method to Circul8Table.vue
    onCustomerSelectionChange(value, field) {
      if (field === "customer_name") {
        // When customer selection changes, emit an event immediately
        this.$emit("customerSelectionChanged", value);
      }
    },
    /**
       * @vuese
       * enable search button

       */
    enableSearch(value, field) {
      let showSearchIcon = false;
      this.checkDependancy(value, field);
      this.fields.every(item => {
        if (
          item.filterKey[item.field] &&
          item.filterKey[item.field].length > 0
        ) {
          if (
            item.type == "dateField" &&
            item.filterKey[item.field][0] === null
          ) {
            showSearchIcon = false;
          } else {
            showSearchIcon = true;
            return false;
          }
        }
        return true;
      });
      if (!showSearchIcon && !this.allSelected) {
        this.greyedFilterIcon = true;
        this.hideRemoveFilterIcon = true;
        if (this.saveDataFields && this.tableName) {
          if (this.isExtertenal) {
            localStorage.removeItem(this.tableName + "SaveDataFieldsExternal");
            localStorage.removeItem(this.tableName + "QueryExternal");
          } else {
            localStorage.removeItem(this.tableName + "SaveDataFields");
            localStorage.removeItem(this.tableName + "Query");
          }
        }
        if (field === "customer_name") {
          this.$emit("customerFilterChanged", value);
        }
        this.$emit("querySet", "");
      } else {
        this.hideRemoveFilterIcon = false;
        this.greyedFilterIcon = false;
        //document.getElementById("mdi-primary-color").style.color = "#2babe2";
      }
    },

    find_column_index(column_name) {
      return this.fields.findIndex(col => col.field === column_name);
    },
    /**
     * @vuese
     * clear filter
     * data removed from column
     * query and data removed from localstorage
     * @arg
     */

    clearData() {
      this.fields.forEach(item => {
        if (item.type == "input") {
          item.filterKey[item.field] = null;
        } else {
          item.filterKey[item.field] = [];
        }
      });
      this.hideRemoveFilterIcon = true;
      if (this.saveDataFields) {
        if (this.isExtertenal) {
          localStorage.removeItem(this.tableName + "SaveDataFieldsExternal");
          localStorage.removeItem(this.tableName + "QueryExternal");
        } else {
          localStorage.removeItem(this.tableName + "SaveDataFields");
          localStorage.removeItem(this.tableName + "Query");
        }
      }
      this.$emit("querySet", "");
      this.allSelected = false;
    },

    clearDataWithoutReload() {
      this.fields.forEach(item => {
        if (item.type == "input") {
          item.filterKey[item.field] = null;
        } else {
          item.filterKey[item.field] = [];
        }
      });
      this.hideRemoveFilterIcon = true;
      if (this.saveDataFields) {
        if (this.isExtertenal) {
          localStorage.removeItem(this.tableName + "SaveDataFieldsExternal");
          localStorage.removeItem(this.tableName + "QueryExternal");
        } else {
          localStorage.removeItem(this.tableName + "SaveDataFields");
          localStorage.removeItem(this.tableName + "Query");
        }
      }
      //this.$emit("querySet", "");
      this.allSelected = false;
    },
    /**
     * @vuese
     * prepare query for search
     * data is stored as a part of columns(fields)
     * save it in localstorage
     * @arg
     */

    searchData() {
      let query = "";
      this.fields.forEach(function(item) {
        if (Array.isArray(item.filterKey[item.field])) {
          let element_key = "id";

          // search query to be used for
          if ("field_name" in item.filterKey) {
            element_key = item.filterKey["field_name"];
          }

          item.filterKey[item.field].forEach(function(elem) {
            if (elem) {
              if (
                item.type == "dateField" &&
                item.filterKey[item.field].length > 0
              ) {
                const dt = new Date(elem);
                const yr = dt.getFullYear();
                const m = dt.getMonth() + 1;
                const d = dt.getDate();
                // this check is because sometimes when date is cleared it adds 1970-1-1 by default
                // check is only for quick fix for the time being
                if (yr != 1970)
                  query = `${query}${item.field}=${yr}-${m}-${d}&`;
              } else if (typeof elem === "object" && !Array.isArray(elem)) {
                query = `${query}${item.field}=${elem[element_key]}&`;
              } else {
                query = `${query}${item.field}=${elem}&`;
              }
            }
          });
        } else {
          if (item.filterKey[item.field]) {
            query = `${query}${item.field}=${item.filterKey[item.field]}&`;
          }
        }
      });
      if (this.saveDataFields && this.tableName) {
        if (this.isExtertenal) {
          localStorage.setItem(
            this.tableName + "SaveDataFieldsExternal",
            JSON.stringify(this.fields)
          );
          localStorage.setItem(this.tableName + "QueryExternal", query);
        } else {
          localStorage.setItem(
            this.tableName + "SaveDataFields",
            JSON.stringify(this.fields)
          );
          localStorage.setItem(this.tableName + "Query", query);
        }
      }
      // query generated for filtering records from database
      this.$emit("querySet", query);
      this.hideRemoveFilterIcon = false;
    },

    classObject(cellValue, colClass) {
      if (cellValue.lastUpdated === true) {
        return {
          "background-last-updated": true
        };
      }
      if (cellValue.isDeleted === true) {
        return {
          "background-red": true
        };
      }
      const reportIsActive = cellValue.active;
      const reportStatus = cellValue.status;
      if (reportIsActive === false || reportStatus == "Report not required") {
        return {
          "background-inactive": true
        };
      } else {
        return colClass;
      }
    },
    AddClassName(row) {
      const classes = [];
      if (this.whiteSpaceNormal) {
        classes.push("add-normal-white-space");
      }
      const customRowClass = row?.rowClassName || row?.rowClass;
      if (customRowClass) {
        if (Array.isArray(customRowClass)) {
          classes.push(...customRowClass);
        } else {
          classes.push(customRowClass);
        }
      }
      return classes.join(" ");
    },
    convertToDate(dt) {
      let newDate = null;
      if (dt != null) {
        newDate = new Date(dt);
        newDate.setHours(0, 0, 0, 0);
      }
      return newDate;
    },
    updateDateFilter(field, range) {
      // dateFilterMap maintains filters applied on just date columns
      if (field in this.dateFilterMap && range[0] == null && range[1] == null) {
        delete this.dateFilterMap[field];
      } else {
        this.dateFilterMap[field] = range;
      }
    },
    filterResultData(records, dateRange, key) {
      const filteredData = [];
      for (const idx in records) {
        const data = records[idx];
        const dateField = this.convertToDate(data[key]);
        if (
          dateField != null &&
          dateRange[0] <= dateField &&
          dateField <= dateRange[1]
        ) {
          filteredData.push(data);
        }
      }
      return filteredData;
    },

    filterData(props, dates) {
      this.updateDateFilter(props.column.field, dates);
      let records = this.records;
      for (const key in this.dateFilterMap) {
        const dateRange = this.dateFilterMap[key];
        records = this.filterResultData(records, dateRange, key);
      }
      this.allRecords = records;
    },
    showContent(obj) {
      obj = obj.replace(/\n/g, "<br />");
      this.$buefy.dialog.alert({
        title: "Additional Information",
        message: obj
      });
    },
    showComment(obj) {
      const objAsHtml = "<div>" + obj + "</div>";
      this.$buefy.dialog.alert({
        title: "Additional Information",
        message: objAsHtml
      });
    },
    /**
     * @vuese
     * emit Edit event
     * @arg The argument is row props of the table
     */
    editModal(editObject) {
      // get the currently clicked row object for edit
      this.$emit("clickEdit", editObject);
    },
    /**
     * @vuese
     * emit Delete event
     * @arg The argument is row props of the table
     */
    deleteModal(editObject) {
      // get the currently clicked  row object for delete
      this.$emit("clickDelete", editObject);
    },
    /**
     * @vuese
     * emit View event
     * @arg The argument is row props of the table
     */
    viewModal(editObject) {
      // get the currently clicked  row object to view
      this.$emit("clickView", editObject);
    },
    /**
     * @vuese
     * emit file download event
     * @arg The argument is row props of the table
     */
    downloadContent(prop, col) {
      this.$emit("downloadFile", prop, col);
    },
    onActionIconClick(row, col) {
      this.$emit("actionIconClick", row, col);
    },
    selectAll(values) {
      let arr = [];
      if (this.allSelected === true) {
        arr = [];
        this.allSelected = false;
      } else {
        this.allSelected = true;
        values.forEach(element => {
          arr.push(element.name);
        });
      }
      this.enableSearch();
      return arr;
    },
    customItem(arr, status, value) {
      this.allSelected = false;
      let col = arr;
      col.includes(value)
        ? (col = col.filter(item => item !== value))
        : col.push(value);
      if (col.length === status.length) {
        this.allSelected = true;
      }
      if (col.length > 0) {
        this.enableSearch();
      }
      return col;
    },

    adjustEmptyTableWidth() {
      const querySelector = document.querySelector(".table-wrapper");
      if (this.records.length > 0) {
        querySelector.style.overflow = "auto";
      } else {
        querySelector.style.overflow = "hidden";
      }
      const emptyTable = document.querySelector(".empty-table-body");
      emptyTable
        ? (emptyTable.style.width = querySelector.offsetWidth - 78 + "px")
        : "";
    },

    limitText(count) {
      return `and ${count} other selected`;
    },
    linkViewforImport(componentName, row) {
      let srting_part = "";
      if (row?.import_type == "Products") {
        srting_part = "product";
      } else {
        srting_part = "transaction";
      }
      if (componentName === "import") {
        return "datamanagement.validation." + srting_part;
      }
      if (componentName === "importRawData") {
        return "datamanagement.viewRawData";
      }
      return;
    },
    assignNumberRangeValue(value1, value2) {
      const index = this.find_column_index(value2);
      this.fields[index].filterKey[value2] = [];
      this.fields[index].filterKey[value2].push(value1.option1);
      this.fields[index].filterKey[value2].push(value1.option2);
      this.enableSearch();
    }
  }
};
</script>

<style scoped>
/* Dropdown styling for better scrolling behavior */
.multiselect__content-wrapper,
.dropdown-content,
.b-dropdown-content {
  max-height: 250px !important;
  overflow-y: auto !important;
  scroll-behavior: smooth;
}

/* Prevent text selection while scrolling in dropdowns */
.multiselect__element,
.dropdown-item {
  user-select: none;
}

/* Add smooth transitions */
.dropdown-menu {
  transition: opacity 0.1s ease, transform 0.2s ease;
}

/* Custom scrollbar for dropdown content */
.multiselect__content-wrapper::-webkit-scrollbar,
.dropdown-content::-webkit-scrollbar,
.b-dropdown-content::-webkit-scrollbar {
  width: 6px;
}

.multiselect__content-wrapper::-webkit-scrollbar-track,
.dropdown-content::-webkit-scrollbar-track,
.b-dropdown-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.multiselect__content-wrapper::-webkit-scrollbar-thumb,
.dropdown-content::-webkit-scrollbar-thumb,
.b-dropdown-content::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 3px;
}

.multiselect__content-wrapper::-webkit-scrollbar-thumb:hover,
.dropdown-content::-webkit-scrollbar-thumb:hover,
.b-dropdown-content::-webkit-scrollbar-thumb:hover {
  background: #aaa;
}
</style>
